import SmoothScrollIntoView from '../__frontend/smoothScrollIntoView';
import setHeaderHeight from '../__frontend/setHeaderHeight';
import Forms from '../__frontend/forms';
import viewportUnits from '../__frontend/viewportUnits';
import delayedScripts from '../__frontend/delayedScripts';
import sectionsInView from '../__frontend/sectionsInView';
import pageScroll from '../__frontend/pageScroll';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		setHeaderHeight();
		viewportUnits();
		delayedScripts();
		sectionsInView();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
	},
	resized() {
		viewportUnits();
		setHeaderHeight();
		sectionsInView();
	},
	scrolled() {
		pageScroll();
	},
	keyDown() {},
	mouseUp() {},
};
export default controller;
